if (!customElements.get('schwer-protection-selector')) {
  customElements.define('schwer-protection-selector', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-protection-tab]')];
      this.panels = [...this.querySelectorAll('[data-protection-panel]')];
      this.onClick = (event) => { const tab = event.target.closest('[data-protection-tab]'); if (tab && this.contains(tab)) this.activate(tab); };
      this.onKeydown = (event) => {
        const tab = event.target.closest('[data-protection-tab]');
        if (!tab || !this.tabs.length) return;
        const current = this.tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(this.tabs[next], true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); this.removeEventListener('keydown', this.onKeydown); }
    activate(tab, focus = false) {
      const id = tab?.dataset.protectionTab;
      const panel = this.panels.find((item) => item.dataset.protectionPanel === id);
      if (!panel) return;
      this.tabs.forEach((item) => { const active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
      this.panels.forEach((item) => item.classList.toggle('is-active', item === panel));
      if (focus) tab.focus();
    }
  });
}
